import {pxToRem} from '../../utills/pxToRem'

export const normalTextStyle = {
    fontFamily: 'Montserrat',
    fontSize: {base: pxToRem(12), lg: pxToRem(13)},
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1)
}

export const orderProductStyle = {
    span: {
        ...normalTextStyle,
        color: 'cav_light_input_gray'
    },
    h2: {
        margin: '0 !important'
    },
    '.product-attr': {
        gap: pxToRem(10),
        '>div': {
            margin: '0 !important',
            flexDir: 'column',
            alignItems: 'start'
        },
        s: {
            ...normalTextStyle
        },
        p: {
            ...normalTextStyle
        },
        b: {
            ...normalTextStyle,
            fontWeight: 'normal'
        }
    }
}

export const orderEGiftCardStyle = {
    flexDir: 'row',
    margin: '0 !important',
    '.image-container': {
        mr: 4
    },
    h2: {
        ...normalTextStyle,
        fontWeight: 'normal',
        color: 'black',
        margin: '0 !important'
    },
    span: {
        ...normalTextStyle,
        color: 'cav_light_input_gray'
    },
    b: {
        ...normalTextStyle,
        fontWeight: 'normal'
    },
    p: {
        ...normalTextStyle,
        fontWeight: 'normal'
    }
}
